import { Table } from "@/features/Table";
import { type E3StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterE3StaticDatumsSchema,
  FilterE3StaticDatums,
} from "./filter";

const client = "e3";
const table_name = "e3_static_data";

export const E3StaticDatumsTable = () => {
  return (
    <Table<E3StaticDatum, FilterE3StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterE3StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
